<template>
  <landing-page
    label="factSheet.colorectalCancerTitle"
    labelColor="#603813"
    descColor="#603813"
    :eggImgObj="{ componentName: 'factsheet', imgName: 'colorectalCancerLandingImage', imgFormat: 'png' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownRight', imgFormat: 'svg' }"
  />

  <div id="infoGroup" style="width: 60vw" class="fact-sheet-subpages pt-16 text-2xl font-jost space-y-12 m-auto pb-24">
    <div v-html="t('factSheet.cervicalCancerDesc')" class="space-y-12" />

    <div>
      <div class="font-bold text-description">{{ t("factSheet.riskFactors") }}</div>
      <div v-html="t('factSheet.colorectalRiskFactorsDesc')" class="space-y-5" />
    </div>

    <div>
      <ul class="bullet-big">
        <template v-for="(item, index) in factSheetStore.colorectalRiskFactorsList" :key="'colorectalRiskFactors' + index">
          <li v-html="t(item.label)" />
        </template>
      </ul>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.signsAndSymptoms") }}</div>
      <div v-html="t('factSheet.signsAndSymptomsDesc')" class="space-y-5" />
    </div>

    <div>
      <ul class="bullet-big">
        <template v-for="(item, index) in factSheetStore.colorectalSignsAndSymptomsList" :key="'colorectalSignsAndSymptoms' + index">
          <li v-html="t(item.label)" />
        </template>
      </ul>
    </div>

    <div v-html="t('factSheet.symptomsSimilarDesc')" class="space-y-5" />

    <div>
      <div class="font-bold text-description">{{ t("factSheet.preventionOfColorectalCancer") }}</div>
      <div v-html="t('factSheet.preventionOfColorectalCancerDesc')" class="space-y-5" />
    </div>

    <div>
      <ol>
        <template v-for="(item, index) in factSheetStore.colorectalPreventionList" :key="'colorectalPrevention' + index">
          <li v-html="t(item.label)" />
        </template>
      </ol>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.cholerectalCancerScreening") }}</div>
      <div v-html="t('factSheet.cholerectalCancerScreeningDesc')" class="space-y-5" />
    </div>

    <div>
      <ol>
        <template v-for="(item, index) in factSheetStore.colorectalScreeningList" :key="'cervicalCancerOtherSymptoms' + index">
          <li v-html="t(item.label)" />
        </template>
      </ol>
    </div>

    <div v-html="t('factSheet.cholerectalRef')" class="space-y-5" />

    <!-- Chinese Version -->
    <section class="!font-sanstc space-y-12">
      <div>
        <div class="font-bold text-description text-center text-4xl">{{ t("factSheetChinese.colorectalCancer") }}</div>
      </div>
      <div v-html="t('factSheetChinese.cervicalCancerDesc')" class="space-y-12" />

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.riskFactors") }}</div>
        <div v-html="t('factSheetChinese.colorectalRiskFactorsDesc')" class="space-y-5" />
      </div>

      <div>
        <ul class="bullet-big">
          <template v-for="(item, index) in factSheetStore.colorectalRiskFactorsList" :key="'colorectalRiskFactors' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ul>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.signsAndSymptoms") }}</div>
        <div v-html="t('factSheetChinese.signsAndSymptomsDesc')" class="space-y-5" />
      </div>

      <div>
        <ul class="bullet-big">
          <template v-for="(item, index) in factSheetStore.colorectalSignsAndSymptomsList" :key="'colorectalSignsAndSymptoms' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ul>
      </div>

      <div v-html="t('factSheetChinese.symptomsSimilarDesc')" class="space-y-5" />

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.preventionOfColorectalCancer") }}</div>
        <div v-html="t('factSheetChinese.preventionOfColorectalCancerDesc')" class="space-y-5" />
      </div>

      <div>
        <ol>
          <template v-for="(item, index) in factSheetStore.colorectalPreventionList" :key="'colorectalPrevention' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ol>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.cholerectalCancerScreening") }}</div>
        <div v-html="t('factSheetChinese.cholerectalCancerScreeningDesc')" class="space-y-5" />
      </div>

      <div>
        <ol>
          <template v-for="(item, index) in factSheetStore.colorectalScreeningList" :key="'cervicalCancerOtherSymptoms' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ol>
      </div>

      <div v-html="t('factSheetChinese.cholerectalRef')" class="space-y-5" />
    </section>
  </div>
</template>

<script setup lang="ts">
import { useFactSheetStore } from "@/stores/factSheet";
import { useHeaderStore } from "@/stores/header";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const factSheetStore = useFactSheetStore();
const headerStore = useHeaderStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {
  headerStore.routerName = 'factsheet';
});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>